// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__nw2Tn","titleContainer":"Modal_titleContainer__U8oxv","title":"Modal_title__ftVie","closeButton":"Modal_closeButton__7LnbR"};